//-----------
// is number
//-----------
export default function isNumber(value) {
  // return typeof value === "number";
  return !isNaN(parseFloat(value)) && isFinite(value)
}
